export default __webpack_public_path__ + "static/media/640_dummy2016-delikatessen01-mobile.19186c62.png";